import { updateFontSizes } from '@utils/fontSizing'

interface StepLabelProps {
  content?: string | null
  as?: keyof JSX.IntrinsicElements
  className?: string
  [key: string]: any
}

const StepLabel = ({ content, as: Component = 'div', className, ...props }: StepLabelProps) => {
  if (!content) {
    return null
  }
  const processedContent = updateFontSizes(content)
  return <Component className={className} dangerouslySetInnerHTML={{ __html: processedContent }} {...props} />
}

export default StepLabel
